import { axios } from "@/services/axios/config";

/**
 * API function to fetch worker details
 * @param payload 
 * @returns { Promise }
 */
export const getWorker = (payload: any) => {
    return axios.post('auth/pro_details', payload)
        .then((response) => {
            return Promise.resolve(response)
        })
        .catch((err) => {
            return Promise.reject(err)
        })
}

/**
 * API function to fetch pro ratings
 * @param account_id
 * @param page
 * @param page_size
 * @returns { Promise }
 */
export const getProRatings = (account_id: number, page: number = 1, page_size: number = 10) => {
    return axios.post('/auth/pro_ratings', { account_id }, { params: { page, page_size } })
        .then((response) => Promise.resolve(response))
        .catch((err) => Promise.reject(err))
}

/**
 * API function to search for workers
 * @param payload 
 * @param config 
 * @returns { Promise }
 */
export const searchWorkers = (payload: any, config: any) => {
    if (!payload.town) {
        payload.town = null
    }

    if (!payload.keywords) {
        payload.keywords = null
    }

    if (!payload.department) {
        payload.department = null
    }

    if (!payload.platform_code) {
        payload.platform_code = null
    }

    return axios.post('/auth/search_pro', payload, config)
        .then((response) => {
            return Promise.resolve(response)
        })
        .catch((err) => {
            return Promise.reject(err)
        })
}